

const stateData = {
    "Connecticut": {
        id: 'US-CT',
        active: true,
        year: 2019,
        date: '2019-10-12',
        time: '3:52:24',
        others: 'Mark',
        raceName: "Hartford Marathon",
        photos: [
            { url: "images/CT/IMG_1785.jpeg"},
            { url: "images/CT/IMG_4370.jpeg"},
            { url: "images/CT/IMG_E1757.jpeg"}
        ]
    },
    "Delaware": {
        id: 'US-DE',
        active: true,
        year: 2021,
        date: '2021-05-15',
        time: '4:22:00',
        others: 'Trevor',
        raceName: "Race 4 Warriors Marathon",
        photos: [
            { url: "images/DE/PXL_20210515_223221471.MP.jpg"}
        ]
    },
    "Florida": {
        id: 'US-FL',
        active: true,
        year: 2025,
        date: '2025-01-12',
        time: '5:00:10',
        others: 'Mark, Frances and Trevor',
        raceName: "Disney Marathon",
        photos: [
            { url: "images/FL/1.jpg"},
            { url: "images/FL/2.jpg"},
            { url: "images/FL/3.jpg"},
            { url: "images/FL/4.jpg"},
            { url: "images/FL/5.jpg"}
        ]
    },
    "Georgia": {
        id: 'US-GA',
        active: true,
        year: 2024,
        date: '2024-02-25',
        time: '3:33:31',
        others: 'Mark and Frances',
        raceName: "Publix Atlanta Marathon",
        photos: [
            { url: "images/GA/1.jpg"},
            { url: "images/GA/2.jpg"}
        ]
    },
    "Illinois": {
        id: 'US-IL',
        active: true,
        year: 2018,
        date: '2018-10-07',
        time: '4:12:37',
        others: 'Mark and Mara',
        raceName: "Chicago Marathon",
        photos: [
            { url: "images/IL/IMG_2705.jpeg"},
            { url: "images/IL/IMG_20181006_104737268.jpg"},
            { url: "images/IL/IMG_20181006_112643553.jpg"},
            { url: "images/IL/MVIMG_20181006_114154317.jpg"},
            { url: "images/IL/MVIMG_20181007_164348913.jpg"},
            { url: "images/IL/MVIMG_20181007_210857611.jpg"}
        ]
    },
    "Maine": {
        id: "US-ME",
        active: true,
        year: 2023,
        date: '2023-05-14',
        time: '3:32:03',
        raceName: "Sugarloaf Marathon",
        photos: [
            { url: "images/ME/1.jpg"},
            { url: "images/ME/2.jpg"},
            { url: "images/ME/3.jpg"},
            { url: "images/ME/4.jpg"},
            { url: "images/ME/5.jpg"},
            { url: "images/ME/6.jpg"},
            { url: "images/ME/7.jpg"},
            { url: "images/ME/8.jpg"},
            { url: "images/ME/9.jpg"},
            { url: "images/ME/10.jpg"},
            { url: "images/ME/11.jpg"},
            { url: "images/ME/12.jpg"},
            { url: "images/ME/13.jpg"},
            { url: "images/ME/14.jpg"},
            { url: "images/ME/15.jpg"}
        ]
    },
    "Maryland": {
        id: 'US-MD',
        upcoming: true,
        year: 2025,
        date: '2025-10-18',
        raceName: "Baltimore Marathon",
        photos: [
        ]
    },
    "Massachusetts": {
        id: 'US-MA',
        active: true,
        year: 2018,
        date: '2018-04-16',
        time: '4:36:21',
        raceName: "Boston Marathon",
        photos: [
            { url: "images/MA/1.jpeg"},
            { url: "images/MA/IMG_6549.jpeg"},
            { url: "images/MA/untitled-587.jpeg"},
            { url: "images/MA/untitled-778.jpeg"},
            { url: "images/MA/untitled-788.jpeg"}
        ]
    },
    "Missouri": {
        id: 'US-MO',
        active: true,
        year: 2023,
        date: '2023-10-21',
        time: '3:50:01',
        raceName: "Kansas City Marathon",
        photos: [
            { url: "images/MO/PXL_20231021_110716023.jpg"},
            { url: "images/MO/PXL_20231021_114749865.jpg"},
            { url: "images/MO/PXL_20231021_121144162~2.jpg"},
            { url: "images/MO/PXL_20231021_140249368.jpg"},
            { url: "images/MO/PXL_20231021_141922568.jpg"},
            { url: "images/MO/PXL_20231021_153242862.TS.mp4", video: true},
            { url: "images/MO/PXL_20231021_155417977.jpg"},
            { url: "images/MO/PXL_20231021_160000332.jpg"},
            { url: "images/MO/PXL_20231021_210556247.jpg"}
        ]
    },
    "Nebraska": {
        id: 'US-NE',
        active: true,
        year: 2024,
        date: '2024-05-05',
        time: '3:28:29',
        isBQ: true,
        raceName: "Lincoln Marathon",
        photos: [
            { url: "images/NE/1.jpg"},
            { url: "images/NE/2.jpg"},
            { url: "images/NE/3.jpg"},
            { url: "images/NE/4.jpg"},
            { url: "images/NE/5.jpg"},
            { url: "images/NE/6.jpg"},
            { url: "images/NE/7.jpg"},
            { url: "images/NE/8.jpg"},
            { url: "images/NE/9.jpg"},
            { url: "images/NE/10.jpg"},
            { url: "images/NE/11.jpg"},
            { url: "images/NE/12.mp4", video: true}
        ]
    },
    "New Jersey": {
        id: 'US-NJ',
        active: true,
        year: 2021,
        date: '2021-04-10',
        time: '',
        others: 'Mark, Frances and Trevor',
        raceName: "New Jersey Marathon",
        photos: [
            { url: "images/NJ/1.jpeg"},
            { url: "images/NJ/IMG_2232.jpg"},
            { url: "images/NJ/IMG_2234.jpg"},
            { url: "images/NJ/IMG_2371.jpg"},
            { url: "images/NJ/IMG-7576.mp4", video: true},
            { url: "images/NJ/IMG-7598.jpeg"},
            { url: "images/NJ/IMG-7604.jpeg"},
            { url: "images/NJ/PXL_20210410_143331513.jpeg"}
        ]
    },
    "New York": {
        id: 'US-NY',
        active: true,
        year: 2016,
        date: '2016-11-20',
        time: '3:30:55',
        genderPlace: 3,
        isBQ: true,
        raceName: "Brooklyn Marathon",
        photos: [
            { url: "images/NY/20161120_092450.jpeg"},
            { url: "images/NY/20161124_094129.jpeg"},
            { url: "images/NY/1.jpeg"},
            { url: "images/NY/IMG_6215.jpeg"}
        ]
    },
    "North Dakota": {
        id: 'US-ND',
        upcoming: true,
        year: 2026,
        date: '2026-09-20',
        raceName: "Bismarck Marathon",
        photos: [
        ]
    },
    "Ohio": {
        id: 'US-OH',
        active: true,
        year: 2023,
        date: '2023-05-07',
        time: '3:26:40',
        isBQ: true,
        raceName: "Flying Pig Marathon",
        photos: [
            { url: "images/OH/10.jpg"},
            { url: "images/OH/2.jpg"},
            { url: "images/OH/3.jpg"},
            { url: "images/OH/4.jpg"},
            { url: "images/OH/vid1.mp4", video: true},
            { url: "images/OH/vid2.mp4", video: true},
            { url: "images/OH/vid3.mp4", video: true},
            { url: "images/OH/5.jpg"},
            { url: "images/OH/6.jpg"},
            { url: "images/OH/7.jpg"},
            { url: "images/OH/8.jpg"},
            { url: "images/OH/9.jpg"},
            { url: "images/OH/1.jpg"},
            { url: "images/OH/11.jpg"},
            { url: "images/OH/12.jpg"},
            { url: "images/OH/13.jpg"},
            { url: "images/OH/14.jpg"},
            { url: "images/OH/15.jpg"}
        ]
    },
    "Oregon": {
        id: 'US-OR',
        active: true,
        year: 2024,
        date: '2024-10-20',
        time: '3:24:56',
        agePlace: 1,
        genderPlace: 4,
        overallPlace: 8,
        isBQ: true,
        raceName: "Columbia Gorge Marathon",
        photos: [
            { url: "images/OR/1.jpeg"},
            { url: "images/OR/2.jpeg"},
            { url: "images/OR/3.jpeg"},
            { url: "images/OR/4.jpeg"}
        ]
    },
    "Pennsylvania": {
        id: 'US-PA',
        active: true,
        year: 2015,
        date: '2015-11-22',
        time: '3:55:01',
        others: 'Mark',
        raceName: "Philadelphia Marathon",
        photos: [
            { url: "images/PA/1.jpeg"}
        ]
    },
    "South Carolina": {
        id: 'US-SC',
        active: true,
        year: 2024,
        date: '2024-12-14',
        time: '3:47:13',
        others: 'Mark, Frances, Trevor, Stephen, Ingrid, Leslie',
        raceName: "Kiawah Island Marathon",
        photos: [
            { url: "images/SC/1.jpg"},
            { url: "images/SC/2.jpg"},
            { url: "images/SC/3.jpg"},
            { url: "images/SC/4.jpg"}
        ]
    },
    "Vermont": {
        id: 'US-VT',
        active: true,
        year: 2021,
        date: '2021-10-24',
        time: '3:35:00',
        others: 'Mark, Frances, Trevor, Karen, Colum',
        raceName: "Vermont City",
        photos: [
            { url: "images/VT/vermont_1.jpeg"},
            { url: "images/VT/IMG_1092.jpeg"},
            { url: "images/VT/IMG_1108.jpeg"},
            { url: "images/VT/IMG_8684.jpg"},
            { url: "images/VT/IMG_8686.jpg"},
            { url: "images/VT/IMG_8738.jpg"},
            { url: "images/VT/PXL_20211024_202613161.jpeg"},
            { url: "images/VT/PXL_20211024_151041942.jpeg"}
        ]
    },
    "Rhode Island": {
        id: 'US-RI',
        name: "Rhode Island",
        year: 2022,
        date: '2022-05-01',
        time: '3:39:43',
        others: 'Mark, Frances, Trevor',
        raceName: "Providence Marathon",
        photos: [
            { url: "images/RI/1.jpeg"},
            { url: "images/RI/2.jpeg"},
            { url: "images/RI/IMG_4950.jpg"},
            { url: "images/RI/IMG_4932.jpg"},
            { url: "images/RI/IMG_4944.jpg"}
        ],
        active: true
    },
    "South Dakota": {
        id: 'US-SD',
        name: "South Dakota",
        year: 2017,
        date: '2017-10-08',
        time: '3:49:24',
        agePlace: 1,
        raceName: "Crazy Horse Marathon",
        photos: [
            { url: "images/SD/1.jpeg"},
            { url: "images/SD/2.jpeg"},
            { url: "images/SD/3.jpeg"}
        ],
        active: true
    },
    "Utah": {
        id: 'US-UT',
        active: true,
        overallPlace: 2,
        year: 2025,
        date: '2025-04-26',
        time: '4:52:12',
        others: 'Mara and Tammy',
        raceName: "Thelma and Louise Marathon",
        photos: [
            { url: "images/UT/1.jpeg"},
            { url: "images/UT/2.jpeg"},
            { url: "images/UT/3.jpeg"},
            { url: "images/UT/4.jpeg"},
            { url: "images/UT/5.jpeg"},
            { url: "images/UT/6.jpeg"},
            { url: "images/UT/7.jpeg"},
            { url: "images/UT/8.jpeg"}
        ]
    },
    "Virginia": {
        id: 'US-VA',
        active: true,
        year: 2022,
        date: '2022-05-16',
        time: '3:58:13',
        agePlace: 3,
        raceName: "Tidewater Striders Marathon",
        photos: [
            { url: "images/VA/PXL_20220424_104128912.jpg"},
            { url: "images/VA/PXL_20220424_150315483.jpg"},
            { url: "images/VA/PXL_20220424_150448674.jpg"},
            { url: "images/VA/PXL_20220424_165643614.jpg"},
            { url: "images/VA/PXL_20220424_175208228.jpg"}
        ]
    },
    "Washington": {
        id: 'US-WA',
        active: true,
        year: 2014,
        date: '2014-11-30',
        time: '3:55:57',
        raceName: "Seattle Marathon",
        photos: [
            { url: "images/WA/1.jpeg"},
            { url: "images/WA/2.jpeg"}
        ]
    },
    "West Virginia": {
        id: 'US-WV',
        active: true,
        year: 2023,
        date: '2023-08-26',
        time: '4:14:22',
        agePlace: 1,
        genderPlace: 2,
        raceName: "Moonlight on the Falls Marathon",
        photos: [
            { url: "images/WV/PXL_20230827_061619925.jpg"},
            { url: "images/WV/PXL_20230827_061623736.jpg"},
            { url: "images/WV/PXL_20230827_061632812.jpg"},
            { url: "images/WV/PXL_20230827_061712220.jpg"},
            { url: "images/WV/PXL_20230827_063243885.jpg"},
        ]
    }
}

export default stateData;